export default {
  buildUrl(base, queries) {
    let url = '?';
    const keys = Object.keys(queries).filter(key => queries[key]);
    keys.forEach((key, index) => {
      url += `${key}=${queries[key]}`;
      if (index < keys.length - 1) url += '&';
    });
    return `${base}${url}`;
  },

   // close dropdown when clicked outside
  closeDropdown(e, dropdownState) {
    if (e.target.dataset.toggle !== 'dropdown' && e.target.parentElement.dataset.toggle !== 'dropdown') {
      if (dropdownState === true) {
        return false;
      }
    }
    return true;
  },
};



// WEBPACK FOOTER //
// ./src/app/utils/helpers.js